import { useAuthorizedInstallersDashboardContext } from '@authorizedInstaller/contexts';
import { TextField } from '@mui/material';

const Contact = () => {
    const { installerRequest } = useAuthorizedInstallersDashboardContext();
    return (
        <div className="grid grid-cols-2 gap-4">
            <TextField
                disabled
                label="Address"
                value={`${installerRequest?.user.address1} ${installerRequest?.user.address2}`}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="City"
                value={installerRequest?.user.city}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Country"
                value={installerRequest?.user.country?.name}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="State/Province"
                value={installerRequest?.user.state}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Phone"
                value={installerRequest?.user.phone_number}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Email"
                value={installerRequest?.user.email}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
        </div>
    );
};

export { Contact };
